const multiColumnLayoutToColSpan = (columns: number, colSpan: number) => {
  let classes = '';

  if (columns === 2) {
    classes = 'one-whole-at-medium';
  }

  if (columns === 3) {
    if (colSpan === 2) {
      classes = 'two-thirds-at-medium';
    }
    if (colSpan === 2 || colSpan === 3) {
      classes = 'one-whole-at-medium';
    }
  }

  if (columns === 4) {
    if (colSpan === 2) {
      classes = 'one-whole-at-medium one-half-at-large';
    }
    if (colSpan === 3) {
      classes = 'one-whole-at-medium three-fourths-at-large';
    }
    if (colSpan === 4) {
      classes = 'one-whole-at-medium';
    }
  }

  return classes;
};

export default multiColumnLayoutToColSpan;
